import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import stringifyParams from "@/utils/stringifyParams";

const useLazyAssignmentGet = () => {
  const createResource = useCallback(({ id, queryParams = {}, skip }) => {
    if (skip) return undefined;

    const resource = `${API_BASE_URL}/api/v3/assignment/${id}/`;
    const queryString = stringifyParams(queryParams);
    return `${resource}${queryString}`;
  }, []);
  return useLazyRestQuery(createResource);
};

export default useLazyAssignmentGet;
